<template>
  <section
    :id="`fk-block-${id}`"
    class="fk-block !mb-base"
    :class="sectionClasses"
  >
    <NuxtPicture
      v-if="image && image.data"
      :provider="image.data.attributes.provider"
      :src="image.data.attributes.hash"
      :width="image.data.attributes.width"
      :height="image.data.attributes.height"
      :sizes="'xs:100vw sm:100vw md:100vw lg:100vw xl:100vw xxl:100vw'"
      :loading="'eager'"
      :alt="image?.data.attributes.alternativeText"
      class="aspect-video opa md:aspect-[2/1] lg:aspect-[3/1] 2xl:aspect-[4/1] select-none block relative -z-10 after:absolute after:inset-x-0 after:-bottom-[1px] after:h-2/3 after:bg-gradient-to-t after:from-light"
      :img-attrs="{
        class: 'object-cover h-full w-full',
      }"
    />
    <div
      class="pt-base"
      :class="{
        '-mt-base pt-0': image && image.data,
      }"
    >
      <SiteBreadcrumbs />
      <RichText v-if="text" :text="text" class="max-w-2xl" />
      <SiteButtons :buttons="buttons" />
    </div>
  </section>
</template>

<script setup lang="ts">
import type { BlockIntro } from "@flyingkiwi/nuxt-components";
const props = defineProps<BlockIntro>();
const { blockClasses } = useBlock();
const sectionClasses = computed(() => {
  return blockClasses(props);
});
</script>

<style lang="css" scoped>
.centered {
  @apply !mb-4;
}
.centered :deep(nav),
.centered > div > div {
  @apply !max-w-3xl mx-auto;
}
</style>
